"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSmartAI2Banner = void 0;
var react_1 = require("react");
var VarnishContext_1 = require("../VarnishContext");
/**
 * Sets up the logic required to toggle the visibility of the `<Header.AI2Banner />`
 * component as the user scrolls the page.
 *
 * The hook returns an array with three items:
 * 1. A ref that should be assigned to the `<Header.Sticky />` component.
 * 2. A ref that should be assigned to the `<Header.AI2Banner />` component.
 * 3. The top offset that should be set as the CSS `top` property of the
 *    `<Header.Sticky />` component.
 */
function useSmartAI2Banner() {
    var stickyRef = (0, react_1.useRef)(null);
    var bannerRef = (0, react_1.useRef)(null);
    var ctx = (0, react_1.useContext)(VarnishContext_1.VarnishContext);
    var _a = (0, react_1.useState)(0), initialHeaderHeight = _a[0], setHeaderHeight = _a[1];
    var _b = (0, react_1.useState)(0), topOffset = _b[0], setTopOffset = _b[1];
    var lastYPos = (0, react_1.useRef)(0);
    var onScroll = function () {
        // This implements logic that:
        //  1. If the user scrolls down the page, at all, the AI2 banner at the top is hidden.
        //  2. If the user scrolls up, at all, the AI2 banner becomes visible again.
        if (bannerRef.current) {
            var distance = window.scrollY - lastYPos.current;
            lastYPos.current = window.scrollY;
            var shouldBeHidden = distance > 0;
            if (!shouldBeHidden) {
                setTopOffset(0);
                return;
            }
            var height = bannerRef.current.getBoundingClientRect().height;
            var paddingBottom = parseFloat(window.getComputedStyle(bannerRef.current).paddingBottom || '0');
            var offset = -1 * (height - paddingBottom);
            setTopOffset(offset);
        }
    };
    (0, react_1.useEffect)(function () {
        // Obtain the initial height of the header.
        if (stickyRef.current) {
            var height = stickyRef.current.getBoundingClientRect().height;
            setHeaderHeight(height);
        }
        window.addEventListener('scroll', onScroll);
        return function () {
            window.removeEventListener('scroll', onScroll);
        };
    }, [stickyRef]);
    (0, react_1.useEffect)(function () {
        ctx.setHeaderHeight(initialHeaderHeight + topOffset);
    }, [ctx, initialHeaderHeight, topOffset]);
    return [stickyRef, bannerRef, topOffset];
}
exports.useSmartAI2Banner = useSmartAI2Banner;
//# sourceMappingURL=useSmartAI2Banner.js.map